import { useEffect, useRef } from 'react';

export default function BlogHero() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = sectionRef.current?.querySelectorAll('.reveal-on-scroll');
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="relative overflow-hidden h-[360px] md:h-[440px] flex items-center justify-center">
      <img
        src="https://readdy.ai/api/search-image?query=Calm%20serene%20reading%20nook%20with%20soft%20morning%20light%2C%20open%20journal%20and%20cup%20of%20tea%20on%20a%20wooden%20desk%2C%20plants%20nearby%2C%20minimalist%20peaceful%20interior%2C%20warm%20neutral%20tones%2C%20gentle%20shadows%2C%20wellness%20lifestyle%20aesthetic%2C%20editorial%20photography%2C%20tranquil%20atmosphere%2C%20high%20detail%20harmonious%20composition&width=1600&height=800&seq=blog-hero-2026&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40" />

      <div className="relative z-10 w-full px-4 sm:px-6 lg:px-8 text-center">
        <div className="reveal-on-scroll animate-fade-in inline-flex items-center gap-2 bg-accent-500/90 text-foreground-950 text-sm font-label font-medium px-4 py-1.5 rounded-full mb-5">
          <i className="ri-article-line" />
          Daily Tips &amp; Insights
        </div>

        <h1 className="reveal-on-scroll animate-fade-in animation-delay-100 font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight mb-4 text-white">
          The ClearMind Blog
        </h1>

        <p className="reveal-on-scroll animate-fade-in animation-delay-200 text-base sm:text-lg max-w-xl mx-auto text-white/85 font-body leading-relaxed">
          Practical articles on focus, routines, nootropics, and cognitive wellness — written to be useful, not overwhelming.
        </p>
      </div>
    </section>
  );
}